import { createFileRoute } from "@tanstack/react-router";
import { PlatformComplianceFormPage } from "@/components/compliance/PlatformComplianceFormPage";

export const Route = createFileRoute("/arrepentimiento")({
  component: () => <PlatformComplianceFormPage type="ARREPENTIMIENTO" />,
  head: () => ({
    meta: [
      { title: "Botón de Arrepentimiento — Structura" },
      { name: "description", content: "Ejercé tu derecho de arrepentimiento sobre la contratación de Structura." },
      { name: "robots", content: "noindex, nofollow" },
    ],
  }),
});
